/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from 'vux/src/components/cell';
import Checker from 'vux/src/components/checker/checker';
import CheckerItem from 'vux/src/components/checker/checker-item';
import CheckIcon from 'vux/src/components/check-icon';
import Group from 'vux/src/components/group';
import Popup from 'vux/src/components/popup';
import PopupHeader from 'vux/src/components/popup-header';
import Search from 'vux/src/components/search';
import ViewBox from 'vux/src/components/view-box';
import XButton from 'vux/src/components/x-button';
import TransferDom from 'vux/src/directives/transfer-dom';
export default {
  name: 'OrgTree',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    Cell: Cell,
    Group: Group,
    ViewBox: ViewBox,
    Search: Search,
    XButton: XButton,
    CheckIcon: CheckIcon,
    Checker: Checker,
    CheckerItem: CheckerItem,
    PopupHeader: PopupHeader,
    Popup: Popup
  },
  props: {
    value: Boolean,
    depSerial: String,
    depName: String,
    selectType: {
      type: Number,
      default: 9999
    },
    infoChecked: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      timeh: '',
      depList: [],
      userList: [],
      depChecked: [],
      userChecked: [],
      searchList: [],
      userSubList: [],
      depSubList: [],
      selectList: [],
      userInfo: [],
      userSum: 0,
      depSum: 0,
      allCheck: false,
      searchValue: '',
      searchFlag: false,
      detailFlag: false,
      showFlag: false,
      pagePath: [],
      pageIndex: 1,
      depSerials: '',
      allyeshu: 1,
      initFlag: false,
      xi: false,
      queryState: false
    };
  },
  computed: {
    bodyBottom: function bodyBottom() {
      return this.selectType !== 1 ? '0.41rem' : '0.41rem';
    },
    btnBottom: function btnBottom() {
      return this.selectType !== 1 ? 'padding-bottom:0.065rem' : 'padding-bottom:0.355rem';
    },
    depCheck: function depCheck() {
      return function (obj) {
        var temp = this.depChecked.filter(function (item) {
          return item === obj;
        });
        return temp.length > 0;
      };
    },
    userCheck: function userCheck() {
      return function (obj) {
        var temp = this.userChecked.filter(function (item) {
          return item === obj;
        });
        return temp.length > 0;
      };
    }
  },
  methods: {
    huoqu: function huoqu() {
      var _this2 = this;

      var _this = this;

      var params = {
        pageIndex: _this.pageIndex,
        pageSize: 10,
        search: {
          depParent: _this.depSerials
        }
      };

      if (_this.xi) {
        return;
      }

      _this.$api.Org.getUserInfos(params).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          // 获取人员
          _this.userList = [].concat(_toConsumableArray(_this.userList), _toConsumableArray(data.records));
          _this.initFlag = true;
          _this.pageIndex++;
          _this.allyeshu = data.totalPage;

          if (_this.pageIndex >= data.totalPage + 1) {
            _this.xi = true;
            return;
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    delUser: function delUser(obj) {
      var index = this.userChecked.indexOf(obj);

      if (index > -1) {
        this.userChecked.splice(index, 1);
      }

      this.userInfo = this.userInfo.filter(function (user) {
        return user.userSerial !== obj;
      });
    },
    delOrg: function delOrg(obj) {
      var index = this.depChecked.indexOf(obj);

      if (index > -1) {
        this.depChecked.splice(index, 1);
      }
    },
    onDetail: function onDetail() {
      if (this.userSum + this.depSum === 0) {
        return;
      }

      this.userSelect();
      this.detailFlag = true;
    },
    onJump: function () {
      var _onJump = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dep) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.pageIndex = 1;
                this.xi = false;
                _context.next = 4;
                return this.getOrgList(dep.depSerial, dep.depName, true);

              case 4:
                this.depSerials = dep.depSerial;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onJump(_x) {
        return _onJump.apply(this, arguments);
      }

      return onJump;
    }(),
    onCancel: function onCancel() {
      this.searchFlag = false;
    },
    onSubmit: function onSubmit(value) {
      // this.$utils.Tools.loadShow()
      // this.pagePath = []
      this.getOrgList(this.depSerial, this.depName, false, value); // this.getOrgList(this.depSerial, dep.depName, true)
      // this.searchFlag = true
      // this.$utils.Tools.loadShow()
      // let params = { depParent: this.depSerial,keys: value}
      // this.$api.Org.getDtAcDepSelectListByEntity(params)
      //     .then((response) => {
      //       this.$utils.Tools.loadHide()
      //       const {code, msg, data} = response
      //       if (+code !== this.$code.success) {
      //         this.$utils.Tools.toastShow(msg)
      //       } else {
      //         this.depList = JSON.parse(JSON.stringify(data))
      //         this.initFlag = true
      //       }
      //     })
      //     .catch(() => {
      //       this.$utils.Tools.httpError()
      //     })
    },
    onDepCheck: function onDepCheck() {
      var _this3 = this;

      if (this.selectType === 1) {
        return;
      }

      var depTemp = this.depList.filter(function (dep) {
        return _this3.depChecked.indexOf(dep.depSerial) > -1;
      });
      depTemp.filter(function (item) {
        var obj = JSON.stringify({
          depSerial: item.depSerial,
          depName: item.depName // userNums: item.userNums,

        });

        var index = _this3.depSubList.indexOf(obj);

        if (index > -1) {
          _this3.depSubList.splice(index, 1);
        }

        _this3.depSubList.push(obj);
      });
      this.depSubList = this.depSubList.filter(function (item) {
        var obj = JSON.parse(item);
        return _this3.depChecked.indexOf(obj.depSerial) > -1;
      }); // console.log(this.depSubList,this.depSubList.length,'this.depSubList')

      this.depSum = this.depSubList.length; // this.depSubList.filter((item) => {
      //   let obj = JSON.parse(item)
      //   console.log(this.depSubList,)
      //   this.depSum = this.depSum 
      //   this.depSum = this.depSum + obj.userNums
      // })
    },
    onUserCheck: function onUserCheck() {
      this.userSum = 0;
      var that = this;
      that.userChecked.filter(function () {
        that.userSum = that.userSum + 1;
      });

      if (that.initFlag && that.selectType === 1) {
        that.onSelect();
      }
    },
    userSelect: function userSelect() {
      var _this4 = this;

      this.userInfo = [];

      if (this.userChecked.length > 0) {
        this.$utils.Tools.loadShow();
        this.$api.Org.getUserInfo(JSON.stringify(this.userChecked)).then(function (response) {
          _this4.$utils.Tools.loadHide();

          var code = response.code,
              msg = response.msg,
              data = response.data;

          if (+code !== _this4.$code.success) {
            _this4.$utils.Tools.toastShow(msg);
          } else {
            _this4.userInfo = data;
          }
        }).catch(function () {
          _this4.$utils.Tools.httpError();
        });
      }
    },
    onClose: function onClose() {
      this.showFlag = false;
    },
    onSelect: function onSelect() {
      var _that = this;

      _that.showFlag = false;

      _that.$emit('onSelect', _that.depSubList); // function userHandler() {
      //   let usersInfo = []
      //   if (_that.userChecked.length > 0) {
      //     //先选择人员
      //     _that.$utils.Tools.loadShow()
      //     return _that.$api.Org.getUserInfo(JSON.stringify(_that.userChecked))
      //         .then((response) => {
      //           _that.$utils.Tools.loadHide()
      //           const {code, msg, data} = response
      //           if (+code !== _that.$code.success) {
      //             _that.$utils.Tools.toastShow(msg)
      //           } else {
      //             usersInfo.push(...data)
      //             return usersInfo
      //           }
      //         })
      //         .catch(() => {
      //           return Promise.reject()
      //         })
      //   } else {
      //     return Promise.resolve(usersInfo)
      //   }
      // }
      // function depHandler(usersInfo) {
      //   if (_that.depChecked.length > 0 && _that.selectType !== 1) {
      //     //再选择部门
      //     _that.$utils.Tools.loadShow()
      //     return _that.$api.Org.getUserByOrg(JSON.stringify(_that.depChecked))
      //         .then((response) => {
      //           _that.$utils.Tools.loadHide()
      //           const {code, msg, data} = response
      //           if (+code !== _that.$code.success) {
      //             _that.$utils.Tools.toastShow(msg)
      //           } else {
      //             usersInfo.push(...data)
      //             return usersInfo
      //           }
      //         })
      //         .catch(() => {
      //           return Promise.reject()
      //         })
      //   } else {
      //     return Promise.resolve(usersInfo)
      //   }
      // }
      // function rtnHandler(usersInfo) {
      //   for (const item of usersInfo) {
      //     _that.selectList.push({
      //       userName: item.userLname,
      //       userSerial: item.userSerial,
      //       userTelephone: item.userTelephone,
      //       userDepname: item.userDepname,
      //     })
      //   }
      //   _that.showFlag = false
      //   _that.$emit('onSelect', _that.selectList)
      // }
      // userHandler().then(depHandler).then(rtnHandler).catch(this.$utils.Tools.httpError)
      // userHandler().then(rtnHandler).catch(this.$utils.Tools.httpError)

    },
    getOrgList: function () {
      var _getOrgList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(depSerial, depName, flag, value) {
        var _this5 = this;

        var dep, _flag, _index, index;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.queryState = false;

                if (!flag) {
                  _context2.next = 6;
                  break;
                }

                dep = {
                  depSerial: depSerial,
                  depName: depName
                };
                this.pagePath.push(dep);
                _context2.next = 18;
                break;

              case 6:
                _flag = false;
                _index = 0;
                _context2.t0 = regeneratorRuntime.keys(this.pagePath);

              case 9:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 17;
                  break;
                }

                index = _context2.t1.value;
                _index = index;

                if (!(this.pagePath[index].depSerial === depSerial)) {
                  _context2.next = 15;
                  break;
                }

                _flag = true;
                return _context2.abrupt("break", 17);

              case 15:
                _context2.next = 9;
                break;

              case 17:
                if (_flag) {
                  this.pagePath.splice(+_index + 1, this.pagePath.length - _index - 1);
                }

              case 18:
                if (value) {
                  this.queryState = true;
                } // 直接去掉用获取人员接口


                this.depSerials = depSerial;
                console.log(depSerial, 'depSerial');
                _context2.next = 23;
                return this.$api.Org.getDtAcDepSelectListByEntity({
                  depParent: value ? null : depSerial,
                  keys: value || null
                }).then(function (response) {
                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this5.$code.success) {
                    _this5.$utils.Tools.toastShow(msg);
                  } else {
                    // 获取下级部门
                    _this5.depList = JSON.parse(JSON.stringify(data));
                    _this5.initFlag = true;
                    _this5.userList = [];
                    _this5.xi = false;
                    _this5.pageIndex = 1; // this.huoqu()
                  }
                }).catch(function () {
                  _this5.$utils.Tools.httpError();
                });

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getOrgList(_x2, _x3, _x4, _x5) {
        return _getOrgList.apply(this, arguments);
      }

      return getOrgList;
    }()
  },
  watch: {
    showFlag: function () {
      var _showFlag = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.$emit('input', val);

                if (val) {
                  this.depList = [];
                  this.userList = [];
                  this.depChecked = [];
                  this.userChecked = [];
                  this.searchList = [];
                  this.userSubList = [];
                  this.depSubList = [];
                  this.selectList = [];
                  this.userInfo = [];
                  this.allCheck = false;
                  this.userSum = 0;
                  this.depSum = 0;
                  this.searchValue = '';
                  this.searchFlag = false;
                  this.detailFlag = false;
                  this.pagePath = [];
                  this.initFlag = false; // this.depSubList.push(...this.infoChecked)
                  // this.depSum = this.depSubList.length
                  // this.userChecked.push(...this.infoChecked)
                  // this.userSum = this.userChecked.length

                  this.depSerials = this.depSerial;
                  this.getOrgList(this.depSerial, this.depName, true);
                  console.log(this.depSubList, 'this.depSubList'); // this.depCheck(this.depSerial)
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showFlag(_x6) {
        return _showFlag.apply(this, arguments);
      }

      return showFlag;
    }(),
    value: {
      handler: function handler(val) {
        this.showFlag = val;
      },
      immediate: true
    },
    allCheck: function allCheck(check) {
      var _this6 = this;

      if (check) {
        if (this.depList.length > 0) {
          this.depList.filter(function (dep) {
            if (_this6.depChecked.indexOf(dep.depSerial) === -1) {
              _this6.depChecked.push(dep.depSerial);
            }
          });
        }

        if (this.userList.length > 0) {
          this.userList.filter(function (user) {
            if (_this6.userChecked.indexOf(user.userSerial) === -1) {
              _this6.userChecked.push(user.userSerial);
            }
          });
        }
      } else {
        if (this.depList.length > 0) {
          this.depList.filter(function (dep) {
            for (var index in _this6.depChecked) {
              if (_this6.depChecked[index] === dep.depSerial) {
                _this6.depChecked.splice(index, 1);
              }
            }
          });
        }

        if (this.userList.length > 0) {
          this.userList.filter(function (user) {
            for (var index in _this6.userChecked) {
              if (_this6.userChecked[index] === user.userSerial) {
                _this6.userChecked.splice(index, 1);
              }
            }
          });
        }
      }
    }
  }
};